import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-cream-white/95 backdrop-blur-md z-50 border-b border-warm-gray/20">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <a 
            href="https://instagram.com/elina_tuleuova" 
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center space-x-2 hover:opacity-80 transition-opacity"
          >
            <div className="w-10 h-10 rounded-full bg-warm-sage flex items-center justify-center">
              <span className="text-cream-white font-serif text-xl">Э</span>
            </div>
            <span className="font-serif text-xl text-charcoal">Элина</span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('about')} className="nav-link">
              Обо мне
            </button>
            <button onClick={() => scrollToSection('consultation')} className="nav-link">
              Консультации
            </button>
            <button onClick={() => scrollToSection('art-event')} className="nav-link">
              Груповая терапия
            </button>
            <button 
              onClick={() => scrollToSection('consultation')} 
              className="btn-primary"
            >
              Записаться
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 hover:bg-soft-gray rounded-lg transition-colors"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 space-y-3 animate-in slide-in-from-top">
            <button onClick={() => scrollToSection('about')} className="nav-link-mobile">
              Обо мне
            </button>
            <button onClick={() => scrollToSection('consultation')} className="nav-link-mobile">
              Консультации
            </button>
            <button onClick={() => scrollToSection('art-event')} className="nav-link-mobile">
              Груповая терапия
            </button>
            <button onClick={() => scrollToSection('consultation')} className="btn-primary w-full">
              Записаться
            </button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
